import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

function TableBodyRowContent({
  serviceTranslation,
  deletedList,
}: {
  serviceTranslation: ServiceTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteServiceTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`service-translations/${id}`, token);
  });

  const removeServiceTranslation = () => {
    deleteServiceTranslation.mutate(serviceTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <TranslationRow
      id={serviceTranslation.id}
      deletedList={deletedList}
      sourceTitle={serviceTranslation.service?.label}
      translation={serviceTranslation?.label}
      lang={serviceTranslation?.lang}
      editTo={`/service-translations/update/${serviceTranslation.id}`}
      onDelete={removeServiceTranslation}
      isDeleting={deleteServiceTranslation.isLoading}
    />
  );
}

interface TableProps {
  serviceTranslations: ServiceTranslation[];
  serviceTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function ServiceTranslationsTable({
  serviceTranslations,
  serviceTranslationsToBeDeleted,
}: TableProps) {
  return (
    <TranslationTable sourceLabel="Service">
      {serviceTranslations?.map((serviceTranslation) => (
        <TableBodyRowContent
          serviceTranslation={serviceTranslation}
          key={serviceTranslation?.id}
          deletedList={serviceTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
